export default __webpack_public_path__ + "img/liveRequest.14173c0d.png";